module.exports = __webpack_public_path__ + "static/scentre-group-logo-a9b49b8a7563307b0ba2cd7fb75568f4.png";